import TableHeader from './TableHeader/TableHeader'
import TableItem from './TableItem/TableItem'

import useStyles from './useStyles'

function SuborganizationsTable ({ id, rows, setRows, types, setLoading }) {
  const classes = useStyles()

  return (
    <>
      <div className={classes.root}>
        <div className={classes.tableWrap}>
          <table className={classes.table}>
            <TableHeader />
            <tbody className={classes.tableBody}>
              {rows &&
                rows.map((item, index) => (
                  <TableItem
                    listIndex={index}
                    key={item.suborganizationId}
                    item={item}
                    id={id}
                    types={types}
                    setLoading={setLoading}
                  />
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
export default SuborganizationsTable
